export default "__VITE_ASSET__BhmsBQyZ__"